import { EntityService } from '../../../../service/EntityService';

export class TaxAuthorityService extends EntityService {

  static entity = 'api/app/tax-authority';

}
